import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import { ButtonGroup, ToggleButton, Pagination } from 'react-bootstrap';
import { FaBars, FaThLarge } from 'react-icons/fa';
import TallesAdminTable from './TallesAdminTable';
import TallesAdminCards from './TallesAdminCards';

const TallesAdminView = () => {
  const [modo, setModo] = useState('tabla');
  const [talles, setTalles] = useState([]);
  const [page, setPage] = useState(1);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(talles.length / itemsPerPage);
  // Ordena: primero los que tienen al menos un talle cargado
  const tallesOrdenados = [...talles].sort((a, b) => {
    const aTieneTalle = a.camisa_invierno || a.pantalon_invierno || a.campera || a.camisa_verano || a.borcego;
    const bTieneTalle = b.camisa_invierno || b.pantalon_invierno || b.campera || b.camisa_verano || b.borcego;
    if (aTieneTalle && !bTieneTalle) return -1;
    if (!aTieneTalle && bTieneTalle) return 1;
    return a.legajo - b.legajo;
  });
  const pagedTalles = tallesOrdenados.slice((page - 1) * itemsPerPage, page * itemsPerPage);

  const opciones = [
    { value: 'tabla', icon: <FaBars size={18} /> },
    { value: 'cards', icon: <FaThLarge size={18} /> }
  ];

  // Cargar talles al montar
  React.useEffect(() => {
    const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:4004').replace(/\/$/, '');
    const storedUser = localStorage.getItem('user');
    const user = storedUser ? JSON.parse(storedUser) : null;
    const token = localStorage.getItem('token');
    
    fetch(`${API_URL}/api/indumentaria/talles`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        'x-user-id': String(user?.Legajo || user?.CdEmpleado || '1'),
        'x-user-role': String(user?.IdRol || user?.tipoUsuario || '1')
      }
    })
      .then(res => res.json())
      .then(data => {
        if (data.success && Array.isArray(data.data)) {
          setTalles(data.data);
        }
      })
      .catch(err => console.error('Error cargando talles:', err));
  }, []);

  const handleExportExcel = () => {
    if (!talles || talles.length === 0) {
      alert('No hay datos para exportar.');
      return;
    }
    // Exportar solo empleados con al menos un talle cargado y usando los nuevos campos
    const data = talles
      .filter(t => t.camisa_invierno || t.pantalon_invierno || t.campera || t.camisa_verano || t.borcego)
      .map(t => ({
        'Legajo': t.legajo ?? '',
        'Nombre': t.nombre ?? '',
        'Camisa Invierno': t.camisa_invierno ?? '',
        'Pantalón Invierno': t.pantalon_invierno ?? '',
        'Pantalón Verano': t.pantalon_verano ?? '',
        'Campera': t.campera ?? '',
        'Remera/Camisa Verano': t.remera ?? t.camisa_verano ?? '',
        'Borcego': t.usa_borcego ? (t.borcego ?? '') : ''
      }));
      if (data.length === 0) {
      alert('No hay datos válidos para exportar.');
      return;
    }
      if (data.length === 0) {
      alert('No hay datos válidos para exportar.');
      return;
    }
      const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Talles');
    XLSX.writeFile(wb, 'talles.xlsx');
  };

  return (
    <div className="container mt-4">
      <h3 className="mb-3">Visualización de talles</h3>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <ButtonGroup className="mb-4">
          {opciones.map((op, idx) => (
            <ToggleButton
              key={idx}
              id={`modo-${op.value}`}
              type="radio"
              variant={modo === op.value ? 'primary' : 'outline-primary'}
              name="modo"
              value={op.value}
              checked={modo === op.value}
              onChange={(e) => setModo(e.currentTarget.value)}
              className="d-flex align-items-center justify-content-center"
              style={{ width: '50px', height: '40px' }}
            >
              {op.icon}
            </ToggleButton>
          ))}
        </ButtonGroup>
        <button className="btn btn-success mb-4" onClick={handleExportExcel}>
          Exportar a Excel
        </button>
      </div>

      {modo === 'tabla' ? (
        <TallesAdminTable talles={pagedTalles} />
      ) : (
        <TallesAdminCards talles={pagedTalles} />
      )}
      {/* Paginación tipo Bootstrap */}
      {totalPages > 1 && (
        <div className="d-flex justify-content-between align-items-center mt-3">
          <span className="text-muted small">
            Mostrando {(page - 1) * itemsPerPage + 1} - {Math.min(page * itemsPerPage, talles.length)} de {talles.length}
          </span>
          <Pagination className="mb-0">
            <Pagination.First onClick={() => setPage(1)} disabled={page === 1} />
            <Pagination.Prev onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1} />
            {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
              let pageNum;
              if (totalPages <= 5) {
                pageNum = i + 1;
              } else if (page <= 3) {
                pageNum = i + 1;
              } else if (page >= totalPages - 2) {
                pageNum = totalPages - 4 + i;
              } else {
                pageNum = page - 2 + i;
              }
              return (
                <Pagination.Item
                  key={pageNum}
                  active={pageNum === page}
                  onClick={() => setPage(pageNum)}
                >
                  {pageNum}
                </Pagination.Item>
              );
            })}
            <Pagination.Next onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page === totalPages} />
            <Pagination.Last onClick={() => setPage(totalPages)} disabled={page === totalPages} />
          </Pagination>
        </div>
      )}
    </div>
  );
};

export default TallesAdminView;
